export const components = {
  header: {
    profile: 'Perfil',
    settings: 'Configuración',
    logout: 'Cerrar sesión',
  },
  footer: {
    copyright: 'Todos los derechos reservados.',
  },
};
